import { render, staticRenderFns } from "./ViaggiStandardPage.vue?vue&type=template&id=fbbda8cc&scoped=true&"
import script from "./ViaggiStandardPage.vue?vue&type=script&lang=js&"
export * from "./ViaggiStandardPage.vue?vue&type=script&lang=js&"
import style0 from "./ViaggiStandardPage.vue?vue&type=style&index=0&id=fbbda8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbda8cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
